import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=a0d174e6&scoped=true"
import script from "./IconEdit.vue?vue&type=script&lang=js"
export * from "./IconEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d174e6",
  null
  
)

export default component.exports